module.exports = __webpack_public_path__ + "img/error-500.a371eabc.svg";